import {all, call, fork, put, takeEvery} from "redux-saga/effects";

import {LOGIN_USER, LOGOUT_USER} from "./actionTypes";
import {loginUserError, loginUserSuccess, logoutUserSuccess} from "./actions";
import {login} from "../../../helpers/auth";
import store from "../..";
import {getDelegatee, getDelegator, getProfile, profileUpdated, userUpdated} from "../user/actions";
import {
    getAgentsAction,
    getBdsAction,
    getClientsAction,
    getCustodiansAction,
    getGroupsAction,
    getRiasAction
} from "../../info/actions";
import {getTokens} from "../tokens/actions";

function* loginUser({ payload: { user, history, target } }) {
    try {
        const response = yield call(login, user);

        // Block paused RIA orgs at login (grantees and OAs)
        if (response.pauseUnlocking) {
            localStorage.removeItem("authUser");
            const isTokenManagement = store.getState().Variables?.env?.VARIANT === "TOKEN_MGMT";
            if (isTokenManagement) {
                yield put(loginUserError({
                    message: "Your organization now uses BitGo Token Management. Sign in on BitGo.com.",
                    sunsetBlocked: true
                }));
            } else {
                yield put(loginUserError({
                    message: "Sign-in is not available for this organization. Please contact your administrator."
                }));
            }
            return;
        }

        yield put(loginUserSuccess());
        yield put(userUpdated(response));
        yield put(getProfile(history));
        yield put(getDelegator());
        yield put(getTokens());
        yield put(getDelegatee());
        yield put(getCustodiansAction());
        yield put(getBdsAction());
        yield put(getRiasAction());
        yield put(getAgentsAction());
        yield put(getClientsAction());
        yield put(getGroupsAction());
        if (response && response.status === "PENDING") {
            history.push("/profile");
        } else {
            history.push(target || "/");
        }
    } catch (error) {
        console.error(error);
        yield put(loginUserError(error));
    }
}

function* logoutUser({payload: {history}}) {
    try {
        const originalOrg = localStorage.getItem("originalOrg");
        if (originalOrg) {
            if (originalOrg === "1") {
                localStorage.removeItem("org");
            } else {
                localStorage.setItem("org", originalOrg);
            }
        }
        localStorage.removeItem("authUser");
        localStorage.removeItem("originalOrg");
        yield put(logoutUserSuccess());
        yield put(userUpdated(null));
        yield put(profileUpdated(null));
        history.push("/login");
        window.location.reload();
    } catch (error) {
        yield put(loginUserError(error));
    }
}

export function* watchUserLogin() {
    yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser);
}

function* authSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
}

export default authSaga;
